angular.module("vgresiduos").controller("OrganizationUnitsPermissionGroupListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "unidade/perfis-acesso");
		};
	}
]);
